export { default } from '../../../../components/onboarding/ForwardedSourceConnectedScreen';
